import { Link, usePage } from '@inertiajs/react';
import classNames from 'classnames';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { useRouter } from '../router';
import { Charity, PageProps } from '../types';
import Container from '../UI/Container';

export function SettingsLayout({
  children,
}: {
  children: ReactNode;
}) {
  const { props: { charity }, component } = usePage<PageProps>();

  return (
    <>
      <SettingsHeader charity={charity} component={component} />
      {children}
    </>
  );
}

export function SettingsHeader({
  charity,
  component,
}: {
  charity: Charity;
  component: string;
}) {
  const { t } = useTranslation();
  const { routes } = useRouter();

  return (
    <div className="bg-white border-b">
      <Container className="!py-3 text-center">
        <div className="space-x-2">
          <Link
            href={routes.projects_page()}
            className={tabClasses({
              active: component.startsWith('Backend/Settings/Projects'),
            })}
          >
            {t('backend:projects')}
          </Link>
          {charity.public && (
            <Link
              href={routes.events_page()}
              className={tabClasses({
                active: component.startsWith('Backend/Settings/Events'),
              })}
            >
              {t('backend:events')}
            </Link>
          )}
          <Link
            href={routes.products_page()}
            className={tabClasses({
              active: component.startsWith('Backend/Settings/Products'),
            })}
          >
            {t('backend:products')}
          </Link>
          <Link
            href={routes.donation_forms_page()}
            className={tabClasses({
              active: component.startsWith('Backend/Settings/DonationForms'),
            })}
          >
            {t('backend:donation_forms')}
          </Link>
        </div>
      </Container>
    </div>
  );
}

function tabClasses({
  active,
}: {
  active?: boolean;
}) {
  return classNames(
    'font-medium py-1 px-2 inline-block rounded',
    active
      ? 'bg-blue-200 text-blue-900 hover:text-blue-900'
      : 'text-blue-700 hover:bg-blue-100 hover:text-blue-900'
  );
}
